<template>
  <div id="print-odds">
    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="managerPrintTemplates.length > 0 || skinPrintTemplates.length > 0"
    >
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-theme">{{ $t('templates') }}</span>
        </div>
      </div>
      <v-row
        justify="center"
        align="center"
        :class="
          index % 2 == 0
            ? 'evenResult d-flex no-padding no-margin'
            : 'oddResult d-flex no-padding no-margin'
        "
        v-for="(template, index) in [
          ...managerPrintTemplates,
          ...skinPrintTemplates,
        ]"
        :key="index"
      >
        <v-col cols="12" sm="6" class="pt-2 pb-2 pr-2 pl-2">
          <v-icon left v-if="template.platformId === '0'" color="blue"
            >mdi-account-tie</v-icon
          >
          <v-icon left v-else color="green">mdi-account</v-icon>
          {{ template.templateName }}
        </v-col>

        <v-col cols="12" sm="6" class="pt-2 pb-2 pr-2 pl-2 text-right">
          <v-btn
            :loading="template.isPrinting"
            :disabled="template.isPrinting"
            @click="printTemplateMethod(template)"
            :class="{ 'get-booked-bet-button': template.platformId === '0' }"
          >
            <v-icon left v-if="!template.isPrinting">mdi-printer</v-icon>
            <v-progress-circular
              v-if="template.isPrinting"
              indeterminate
              color="white"
              size="20"
            >
            </v-progress-circular>
            {{ $t('print') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="tournament-card-preview" elevation="1">
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-theme"> {{ $t('printodds') }}</span>
        </div>
      </div>
      <div class="sport-next-events-content">
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="loading"
        ></v-progress-linear>
      </div>

      <div class="print-progress-content">
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="printing"
        >
        </v-progress-linear>

        <div v-if="printing" class="print-message">
          <v-icon left color="primary">mdi-printer</v-icon>
          <span>{{ $t('print_in_progress') }}</span>
        </div>
      </div>

      <v-row justify="center" class="pt-10 pl-4 pr-4">
        <v-col cols="12" md="6">
          <v-select
            v-model="form.orientation"
            :items="orientations"
            :label="textOrintation"
            item-value="value"
            item-text="name"
            outlined
            dense
          >
          </v-select>
          <v-select
            v-model="form.sheet"
            :items="sheets"
            :label="textSheet"
            item-value="value"
            item-text="size"
            outlined
            dense
          >
          </v-select>
          <v-select
            v-model="orderBySelected"
            :items="orderBy"
            :label="$t('orderBy')"
            item-value="value"
            item-text="name"
            outlined
            dense
          >
          </v-select>
          <v-autocomplete
            v-model="sportSelected"
            :items="listSports"
            :label="$t('sport')"
            item-value="id"
            item-text="name"
            :error-messages="errors.sport"
            chips
            deletable-chips
            small-chips
            outlined
            dense
            @change="categorySelect"
          >
          </v-autocomplete>
          <v-autocomplete
            v-model="categorySelected"
            :items="sportCategories"
            :label="$t('country')"
            item-value="id"
            item-text="name"
            :error-messages="errors.category"
            chips
            deletable-chips
            multiple
            small-chips
            outlined
            dense
            @change="categorySelect"
          >
          </v-autocomplete>
          <v-autocomplete
            v-if="categorySelected != null && categorySelected.length == 1"
            v-model="tournamentsSelected"
            :items="categoryTournament"
            :label="$t('tournament')"
            item-value="id"
            item-text="name"
            :error-messages="errors.tournament"
            chips
            deletable-chips
            multiple
            small-chips
            outlined
            dense
          >
          </v-autocomplete>
          <v-autocomplete
            v-if="sportMarketsMini.length > 0"
            v-model="marketsSelected"
            :items="sportMarketsMini"
            :label="$t('markets')"
            item-value="unique_id"
            item-text="nameWithNumberOutcomes"
            :error-messages="errors.markets"
            chips
            deletable-chips
            multiple
            small-chips
            outlined
            dense
            @change="calculateTotalOutcomes"
          >
          </v-autocomplete>

          <v-card v-if="totalNumberOutcomes > 0" class="mt-1" outlined tile>
            <v-card-title>
              <v-icon color="primary" class="mr-1">mdi-chart-bar</v-icon>
              {{ $t('total_outcomes_selected') }}:
            </v-card-title>
            <v-card-text class="display-2 font-weight-bold text-center">
              <small class="text--secondary">
                {{ totalNumberOutcomes }} Outcomes</small
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :label="$t('days')"
            outlined
            v-model="form.days"
            dense
            autocomplete="nope"
            min="1"
            max="30"
            :error-messages="errors.days"
            type="number"
          >
          </v-text-field>
          <v-btn
            block
            target="_blank"
            class="get-booked-bet-button"
            style="background: #fed430; color: #000000; font-weight: bold"
            @click="printSelectedMarkets()"
          >
            {{ $t('print') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
/* todo add is printing variable if possible */
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'

export default {
  name: 'PrintOddsV2',

  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    loading: false,
    markets: [],
    sports: [],
    col: 0,
    sportMarkets: [],
    titleSport: '',

    errors: {
      groupby: '',
      days: '',
      selectone: '',
    },
    size: 0,
    paginate: 0,
    sportMarketsComplete: [],
    odds: [],
    linkdownload: '',
    selectGroup: [],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT + '/category-images/rectangular/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: 'https://rocky-revenge.s3-eu-west-1.amazonaws.com/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/',
    light: window.icons == 'light' ? true : false,
    sport: '',
    textGroup: '',
    textSheet: '',
    textOrintation: '',
    form: {
      markets: [],
      days: 1,
      groupby: 'day',
      sport: '',
      category: [],
      tournament: [],
      sheet: 9,
      orientation: 'landscape',
    },
    sportCategories: [],
    categoryTournament: [],
    sheets: [{ size: 'A4', value: 9 }],
    /*sheets:[{size:"A4",value:9},{size:"A3",value:8}],*/
    sportSelected: null,
    orientations: [],
    sportMarketsMini: [],
    marketsSelected: null,
    categorySelected: null,
    tournamentsSelected: [],
    orderBy: [],
    orderBySelected: 'byTournaments',
    managerPrintTemplates: [],
    skinPrintTemplates: [],
    printing: false,
    totalNumberOutcomes: 0,
    maxNumberOfOutcomesAllowed: 37,
  }),

  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getPlatformId: 'settings/getPlatformId',
      getTree: 'treeV2/getTree',
      getUrlApi: 'settings/getUrlApi',
      getUserId: 'user/getId',
      getTemplateSkin: 'rules/getTemplateSkin' /* deprecated */,
      getTemplateManager: 'rules/getTemplateManager' /* deprecated*/,
    }),
    listSports: function () {
      if (_.size(this.getTree) > 0) {
        let filter = []
        filter = _.filter(this.getTree, { typeOdds: 'prematch' })
        const clean = []
        _.forEach(filter, el => {
          clean.push({ id: el.icon_id, count: el.count, name: el.name })
        })
        return clean
      }
    },
  },
  watch: {
    async sportSelected(newValue, oldValue) {
      if (newValue != null && newValue != '' && newValue != oldValue) {
        const response = await this.apiGetMarketsByPlatformSport({
          sportId: newValue,
          platformId: this.getPlatformId,
          language: this.getLanguage,
        })
        this.sportMarketsMini = []
        this.sportMarketsMini = response.data.result.markets
        this.marketsSelected = []

        const listCategories = await this.fetchCategorySport({
          sport: newValue,
        })
        this.sportCategories = []
        if (_.size(listCategories) > 0) {
          _.forEach(listCategories, list => {
            if (list.active) {
              const nameCat = _.find(list.detail, {
                lang: this.getLanguage,
              }).text
              this.sportCategories.push({ id: list.id, name: nameCat })
            }
          })
        }
        this.sportCategories = _.sortBy(this.sportCategories, ['name'])
      }
    },
  },

  methods: {
    calculateTotalOutcomes() {
      let total = 0

      this.marketsSelected.forEach(selectedId => {
        const market = this.sportMarketsMini.find(
          market => market.unique_id === selectedId
        )
        if (market && market.numberOutcomes) {
          total += market.numberOutcomes
        }
      })

      this.totalNumberOutcomes = total
    },

    async printTemplateMethod(template) {
      const idTemplate = template._id

      this.printing = true
      this.$set(template, 'isPrinting', true)
      const response = await this.printTemplate({ idTemplate: idTemplate })
      this.printing = false
      this.$set(template, 'isPrinting', false)
    },

    // async printSelectedMarkets() {
    //   const vm = this;
    //   vm.loading = true;
    //
    //   if (this.sportSelected == null) {
    //     alert(vm.$t('please_select_sport'));
    //     vm.loading = false;
    //     return
    //   }
    //
    //   if (this.marketsSelected == null || this.marketsSelected.length == 0) {
    //     alert(vm.$t('please_select_markets'));
    //     vm.loading = false;
    //     return
    //   }
    //
    //   if (vm.form.days != null && +vm.form.days > 30) {
    //     alert(vm.$t('insert_shorter_time_interval'));
    //     vm.loading = false;
    //     return
    //   }
    //
    //   try {
    //
    //     this.printing = true;
    //     const sportId = this.sportSelected;
    //     const categoriesIds = this.categorySelected;
    //     let tournamentsIds = this.tournamentsSelected;
    //
    //     if (categoriesIds != null && categoriesIds.length >= 2 && tournamentsIds.length >= 0) {
    //       this.tournamentsSelected = [];
    //       tournamentsIds = this.tournamentsSelected;
    //       // alert('you have selected more categoryies, tournaments are not considered')
    //     }
    //
    //
    //     const response = await this.printOdds({
    //       "platformId": 1,
    //       "sportId": sportId,
    //       "categoriesId": categoriesIds,
    //       "tournamentsIds": tournamentsIds,
    //       "markets": vm.marketsSelected,
    //       "days": vm.form.days,
    //       "groupBy": vm.orderBySelected,
    //       "orientation": vm.form.orientation,
    //       "language": vm.getLanguage,
    //       "sheet": vm.form.sheet
    //     })
    //
    //
    //     if (response == null) {
    //       alert(vm.$t('generic.error'));
    //     }
    //
    //
    //   } catch (e) {
    //     console.log(e)
    //   } finally {
    //     vm.loading = false;
    //     vm.printing = false;
    //   }
    //
    // },

    async printSelectedMarkets() {
      const vm = this
      vm.loading = true

      if (this.sportSelected == null) {
        alert(vm.$t('please_select_sport'))
        vm.loading = false
        return
      }

      if (this.marketsSelected == null || this.marketsSelected.length == 0) {
        alert(vm.$t('please_select_markets'))
        vm.loading = false
        return
      }

      if (vm.form.days != null && +vm.form.days > 30) {
        alert(vm.$t('insert_shorter_time_interval'))
        vm.loading = false
        return
      }

      if (
        vm.totalNumberOutcomes != null &&
        +vm.totalNumberOutcomes > vm.maxNumberOfOutcomesAllowed
      ) {
        alert(
          vm.$t('please_select_max_n_signs', {
            N: this.maxNumberOfOutcomesAllowed,
          })
        )
        vm.loading = false
        return
      }

      try {
        this.printing = true
        const sportId = this.sportSelected
        const categoriesIds = this.categorySelected
        let tournamentsIds = this.tournamentsSelected

        if (
          categoriesIds != null &&
          categoriesIds.length >= 2 &&
          tournamentsIds.length >= 0
        ) {
          this.tournamentsSelected = []
          tournamentsIds = this.tournamentsSelected
          // alert('you have selected more categoryies, tournaments are not considered')
        }

        const response = await this.printOdds({
          platformId: this.getPlatformId,
          sportId: sportId,
          categoriesIds: categoriesIds,
          tournamentsIds: tournamentsIds,
          marketsUniqueIds: vm.marketsSelected,
          days: vm.form.days,
          groupBy: vm.orderBySelected,
          orientation: vm.form.orientation,
          language: vm.getLanguage,
          sheetType: vm.form.sheet,
        })

        if (response == null) {
          alert(vm.$t('generic.error'))
        }
      } catch (e) {
        console.log(e)
      } finally {
        vm.loading = false
        vm.printing = false
      }
    },
    async loadCategoriesForSport(sportId) {
      const listCategories = await this.fetchCategorySport({ sport: sportId })

      this.sportCategories = []
      if (_.size(listCategories) > 0) {
        _.forEach(listCategories, list => {
          if (list.active) {
            const nameCat = _.find(list.detail, { lang: this.getLanguage }).text
            this.sportCategories.push({ id: list.id, name: nameCat })
          }
        })
      }
      this.sportCategories = _.sortBy(this.sportCategories, ['name'])
    },
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    ...mapActions({
      fetchMarketSportPrint: 'tree/fetchMarketSportPrint',
      fetchCategorySport: 'tree/fetchCategorySport',
      fetchTournamentByCategory: 'tree/fetchTournamentByCategory',
      findEvent: 'tree/findEventQuick',
      apiGetMarketsBySportList: 'marketview/apiGetMarketsBySportList',
      printOdds: 'odds/printOdds',
      fetchMyPrintTemplates: 'settings/fetchMyPrintTemplates',
      printTemplate: 'odds/printTemplate',
      apiGetMarketsByPlatformSport: 'marketview/apiGetMarketsByPlatformSport',
    }),
    returnIcon(icon) {
      let response
      switch (icon) {
        case 'B/W':
          response = 'icons'
          break
        case 'Color':
          this.light = false
          response = 'icons_color'
          break
      }
      return response
    },

    async categorySelect() {
      if (this.categorySelected != null) {
        const listTournaments = await this.fetchTournamentByCategory({
          categories: JSON.stringify(this.categorySelected),
        })
        this.categoryTournament = []
        if (_.size(listTournaments) > 0) {
          _.forEach(listTournaments, list => {
            if (list.active) {
              const nameCat = _.find(list.detail, {
                lang: this.getLanguage,
              }).text
              this.categoryTournament.push({ id: list.id, name: nameCat })
            }
          })
        }
      }
    },

    async changePrintOddsV2(sport, name) {
      try {
        this.sport = sport
        this.loading = true
        this.titleSport = name

        const listCategories = await this.fetchCategorySport({ sport: sport })
        this.sportCategories = []
        if (_.size(listCategories) > 0) {
          _.forEach(listCategories, list => {
            if (list.active) {
              const nameCat = _.find(list.detail, {
                lang: this.getLanguage,
              }).text
              this.sportCategories.push({ id: list.id, name: nameCat })
            }
          })
        }
        this.sportCategories = _.sortBy(this.sportCategories, ['name'])

        this.size = _.size(this.sportMarketsComplete)

        if (this.checkIsMobile()) {
          this.col = 12
          this.paginate = 1
        }
        if (this.checkIsTablet()) {
          this.col = 6
          this.paginate = 4
        }
        if (!this.checkIsMobile() && !this.checkIsTablet()) {
          this.col = 2
          this.paginate = 6
        }

        //this.paginate=6
        //this.sportMarkets = _.chunk(this.sportMarketsComplete,this.paginate)
        this.textGroup = this.$t('group') + ' ' + this.titleSport
        this.textSheet = this.$t('sheet')
        this.textOrintation = this.$t('orientation')
        this.sportMarkets = this.sportMarketsComplete
        this.loading = false
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    const responsePrintTemplate = await this.fetchMyPrintTemplates(
      this.getPlatformId
    )

    try {
      this.managerPrintTemplates = responsePrintTemplate.managerPrintTemplates
      this.skinPrintTemplates = responsePrintTemplate.printTemplates
    } catch (e) {
      console.log(e)
    }

    this.orientations = [
      { name: this.$t('horizontal'), value: 'landscape' },
      {
        name: this.$t('vertical'),
        value: 'portrait',
      },
    ]

    this.orderBy = [
      {
        name: this.$t('byTournaments'),
        value: 'byTournaments',
      } /*, {name: this.$t('byDay'), value: 'byDay'}*/,
    ]
    this.selectGroup.push({ name: this.$t('groupday'), id: 'day' })
    this.selectGroup.push({
      name: this.$t('grouptournament'),
      id: 'tournament',
    })
    //this.form.groupby={name:this.$t('groupday'),id:'day'}
    this.form.groupby = 'day'
    this.changePrintOddsV2(this.getTree[0].icon_id, this.getTree[0].name)
  },
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.v-card-title {
  font-size: 14px;
  color: #000;
}

.display-2 .text--secondary {
  font-size: 14px;
  color: #000;
}
</style>
